<template>
    <pc-alert
        v-bind="alertBinder"
        class="mb-0">
        <div>
            <div class="mb-3">
                {{ message }}
            </div>
            <tag-errors v-bind:create-tags-result-model="createTagsResultModel" />
        </div>
    </pc-alert>
</template>
<script>
    import tagErrors from "./tagErrors.vue";
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/tagErrorsDialog.i18n";
    import { ALERT_SEVERITY } from "Util/alerts";

    export default {
        components: {
            tagErrors
        },
        props: {
            createTagsResultModel: { type: Object, required: true },
            infoMessage: { type: String, required: false, default: null }
        },
        computed: {
            message() {
                return this.infoMessage || this.defaultMsg;
            },
            alertBinder() {
                return {
                    shown: true,
                    severity: ALERT_SEVERITY.error
                };
            },
            ...mapI18n(
                {
                    ...KEYS
                },
                NAMESPACE
            )
        }
    };
</script>
